var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.applicationNewComponent,{tag:"component",attrs:{"workflow-policy":_vm.workflowPolicy,"copy":_vm.copy,"customer-id":_vm.customerId}})}
var staticRenderFns = []

export { render, staticRenderFns }